import React, { useState } from 'react'
import { DatePicker } from 'antd'
import { format } from 'date-fns'
import subMinutes from 'date-fns/subMinutes'
import dateFnsGenerateConfig from 'rc-picker/es/generate/dateFns'
import { updateAnswersThunk } from '@/state/answer/thunks'
import { useAppDispatch } from '@/utils/hooks'
import iconStyle from '@sass/common/icon.module.sass'
import commonStyle from '../common.module.sass'
import { AnswerDatetimeBaseProps } from '../types'
import style from './index.module.sass'

const DateFnsDatePicker = DatePicker.generatePicker<Date>(dateFnsGenerateConfig)

const MAX_DATE = new Date(2120, 0, 1)
const MIN_DATE = new Date(1850, 0, 1)

// NOTE: BE CAREFUL WITH TIMEZONES!!!!!
const subTimezoneToLocal = (content: string) => {
	// Replace the timezone WITHOUT chaging time
	// e.g. ie 10am UTC => 10am PST

	// ensure the timezone is from the date, NOT the current time!
	// (very sneaky)
	const tzOffset = new Date(content).getTimezoneOffset()
	return subMinutes(new Date(content), -tzOffset)
}

const localToIsoString = (date: Date) => {
	const tzOffset = date.getTimezoneOffset()
	return subMinutes(date, tzOffset).toISOString()
}

const AnswerDate = (props: AnswerDatetimeBaseProps) => {
	const [date, setDate] = useState(props.answer.content ? subTimezoneToLocal(props.answer.content) : null)
	const dispatch = useAppDispatch()

	const onChange = (date: Date | null) => {
		setDate(date)
		dispatch(
			updateAnswersThunk({ answers: [{ ...props.answer, content: date ? localToIsoString(date) : null }] }),
		)
	}

	return (
		<div className={style.dateInput}>
			{
				props.disabled ?
					<div className={style.disabledRow}>
						<span className={`${style.iconCalendar} ${iconStyle.calendar}`} /> &nbsp;
						{date ? format(date, 'dd/MM/yyyy') : <i className={commonStyle.noContent}>No content</i>}
					</div>
				:	<DateFnsDatePicker
						placeholder={props.field.placeholder || undefined}
						onChange={onChange}
						value={date}
						maxDate={MAX_DATE}
						minDate={MIN_DATE}
						format="dd/MM/yyyy"
					/>
			}
		</div>
	)
}

export default AnswerDate
